import React from 'react';
import { Route } from 'react-router-dom';
import AktienCheckPage from 'modules/analyse/pages/AktienCheckPage';
import analyseReducer from 'modules/analyse/features/analyseSlice';

/**
 * Modul-Definition "Aktien-Check" (analyse).
 *
 * Einziger Export des Moduls an das Portal (Registry in modules/index.js).
 */
const analyseModul = {
  id: 'aktien-check',
  name: 'Aktien-Check',
  description:
    'Tiefenanalyse einer Aktie aus mehreren kostenlosen Quellen inkl. Reddit-Buzz – mit Gesamturteil.',
  path: '/projekte/aktien-check',
  icon: '🔍',
  gradient: 'from-sky-400 to-indigo-600',
  status: 'active',
  reducers: {
    analyse: analyseReducer,
  },
  routes: <Route path="/projekte/aktien-check" element={<AktienCheckPage />} />,
};

export default analyseModul;
